export const selfInstantiateOnLoad = (Class) => {
    if (document.readyState === "complete") {
        new Class();
    }
    else {
        window.addEventListener("DOMContentLoaded", () => new Class());
    }
};
